import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { FamilyGetModel } from "@/commons/services/Families";
import OtherUserGroup from "../models/OtherUserGroup";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 利用者 API 操作クラス
 */
export default class SendMessageGroupMembers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET SendMessageGroupMembers
   */
  public async get(
    userStore: LoginUser,
    groupId: number,
    queryParams?: { startIndex: number; endIndex: number; sortKey: string; order: string }
  ): Promise<Array<SendMessageGroupMembersFamilyGetModel> | Array<SendMessageGroupMembersOtherUserGroupMemberGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      groupId: groupId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendMessageGroupMembers, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<any>>(userStore, requestUrl, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SendMessageGroupMembersFamilyGetModel extends FamilyGetModel {
  groupName: string;
}

export interface SendMessageGroupMembersOtherUserGroupMemberGetModel extends OtherUserGroup {
  groupTypeName: string;
}
